import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  computed,
  inject,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { MatIconModule } from '@angular/material/icon';

import { ExternalLinkService } from '../../../../../shared/services/external-link.service';

export interface WarrantySheetData {
  title?: string;
  description?: string;
  descriptionAsHtml?: boolean;
  confirmLabel?: string;
  showCancel?: boolean;
  cancelLabel?: string;
  requiresAcceptance?: boolean;
  acceptancePrefix?: string;
  acceptanceLinkLabel?: string;
  acceptanceSuffix?: string;
  acceptanceLinkUrl?: string;
}

@Component({
  selector: 'app-warranty-info-dialog',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './warranty-info-dialog.component.html',
  styleUrl: './warranty-info-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarrantyInfoDialogComponent {
  private readonly bottomSheetRef =
    inject(MatBottomSheetRef<WarrantyInfoDialogComponent>);
  private readonly externalLinkService = inject(ExternalLinkService);

  public readonly accepted = signal(false);

  public readonly canConfirm = computed(() => {
    if (!this.data.requiresAcceptance) {
      return true;
    }

    return this.accepted();
  });

  public constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public readonly data: WarrantySheetData,
  ) {}

  public toggleAccepted(): void {
    this.accepted.update((value) => !value);
  }

  public cancel(): void {
    this.bottomSheetRef.dismiss(false);
  }

  public confirm(): void {
    if (!this.canConfirm()) {
      return;
    }

    this.bottomSheetRef.dismiss(true);
  }

  public openAcceptanceLink(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    if (!this.data.acceptanceLinkUrl) {
      return;
    }

    this.externalLinkService.openLinkBasedOnConsent(this.data.acceptanceLinkUrl);
  }
}
